import React from 'react';
import '../../../Css/HotelTable.css'; // Import the CSS file

const HotelTable = ({ hotels, onEdit, onFetch}) => {
  const token = localStorage.getItem('token'); // Get token from localStorage
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleDelete = async (hotelId) => {
    try {
      const response = await fetch(`${apiUrl}/api/hotels/hotel/${hotelId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}`},
      });

      if (response.ok) {
        alert('Hotel deleted successfully');
        onFetch();
      } else {
        const message = await response.text();
        console.error('Failed to delete hotel:', message);
      }
    } catch (error) {
      console.error('Error deleting hotel:', error);
    }
  };

  return (
    <table className="hotel-table">
      <thead className="hotel-table__header">
        <tr>
          <th>Hotel</th>
          <th>category</th>
          <th>Type Chambre</th>
          <th>Type prix</th>
          <th>Logement simple</th>
          <th>Petit déj</th>
          <th>Déjenner</th>
          <th>Dinner</th>
          <th style={{ textAlign: 'center'}}>Actions</th>
        </tr>
      </thead>
      <tbody className="hotel-table__body">
        {hotels.length > 0 ? (
          hotels.map((hotel) => (
            hotel.hotel_rooms.map((room, roomIndex) => {
              const roomDetailsCount = room.room_details.length; // Number of prixtypes for the room
  
              return room.room_details.map((detail, detailIndex) => (
                <tr key={`${hotel.id}-${room.id}-${detailIndex}`} className="hotel-table__row">
                  {/* Display hotel name in the first row, spanning over the number of prixtypes */}
                  {detailIndex === 0 && (
                    <td rowSpan={roomDetailsCount} className="hotel-table__cell hotel-table__cell--hotel-name">
                      {hotel.nameHotel}
                    </td>
                  )}

                  {detailIndex === 0 && (
                    <td rowSpan={roomDetailsCount} className="hotel-table__cell hotel-table__cell--hotel-name">
                      {hotel.category}
                    </td>
                  )}
  
                  {/* Display room name in the first row for each room, spanning over the number of prixtypes */}
                  {detailIndex === 0 && (
                    <td rowSpan={roomDetailsCount} className="hotel-table__cell">
                      {room.room_title}
                    </td>
                  )}
  
                  {/* Display room details (each prixtype) */}
                  <td className="hotel-table__cell">{detail.prixType}</td>
                  <td className="hotel-table__cell">{parseFloat(detail.logsimple).toFixed(3).replace('.', ',')}</td>
                  <td className="hotel-table__cell">{parseFloat(detail.petidej).toFixed(3).replace('.', ',')}</td>
                  <td className="hotel-table__cell">{parseFloat(detail.dejenner).toFixed(3).replace('.', ',')}</td>
                  <td className="hotel-table__cell">{parseFloat(detail.dinner).toFixed(3).replace('.', ',')}</td>
  
                  {/* Display actions on the first row for each room */}
                  {detailIndex === 0 && (
                    <td rowSpan={roomDetailsCount} className="hotel-table__cell hotel-table__cell--actions">
                      <button className="hotel-table__editbutton" onClick={() => onEdit(hotel)}>Modifier</button>
                      <button className="hotel-table__deletebutton" onClick={() => handleDelete(hotel.id)}>Supprimer</button>
                    </td>
                  )}
                </tr>
              ));
            })
          ))
        ) : (
          <tr className="hotel-table__row">
            <td colSpan="10" className="hotel-table__cell hotel-table__cell--no-data">No data available</td>
          </tr>
        )}
      </tbody>
    </table>
  );
  
  
  
};

export default HotelTable;
